import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { PRIMITIVE_COLORS } from 'constants/quartz/primitive_colors';

const CopyContentIcon = ({ fill, height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            {/* L-shaped line - bottom left */}
            <path
                d="M2 4V10.5C2 11.3284 2.67157 12 3.5 12H8"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
            />
            {/* Front rectangle - top right */}
            <rect
                x="5"
                y="1"
                width="8"
                height="8"
                rx="1.5"
                stroke={fill}
                strokeWidth="1.5"
                fill="none"
            />
        </SvgIcon>
    );
};

CopyContentIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

CopyContentIcon.defaultProps = {
    fill: PRIMITIVE_COLORS.neutral.graphite[700],
    height: '14',
    viewBox: '0 0 14 14',
    width: '14',
};

export default CopyContentIcon;
